import React from 'react';
import { useTranslation } from 'react-i18next';

const Header = ({ history, steps, S, step }) => {
  const { t } = useTranslation();
  return (
    <header style={{ padding: '20px 32px', borderBottom: `1px solid ${S.borderLight}`, background: 'rgba(255,255,255,0.8)', flexShrink: 0 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 24 }}>
        <button
          onClick={() => history.push('/claims')}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 34,
            height: 34,
            borderRadius: 8,
            border: `1px solid ${S.borderLight}`,
            background: '#fff',
            cursor: 'pointer',
          }}
        >
          <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke={S.textSecondary} strokeWidth='1.8' strokeLinecap='round' strokeLinejoin='round'>
            <line x1='19' y1='12' x2='5' y2='12' />
            <polyline points='12 19 5 12 12 5' />
          </svg>
        </button>
        <div>
          <div style={{ fontSize: 12, color: S.textMuted, display: 'flex', alignItems: 'center', gap: 6, marginBottom: 2 }}>
            {t('screens.claimsScreen.operations')}
            <svg width='12' height='12' viewBox='0 0 24 24' fill='none' stroke={S.textMuted} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
              <polyline points='9 18 15 12 9 6' />
            </svg>
            {t('screens.claimsScreen.breadcrumbClaims')}
            <svg width='12' height='12' viewBox='0 0 24 24' fill='none' stroke={S.textMuted} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
              <polyline points='9 18 15 12 9 6' />
            </svg>
            <span style={{ color: S.textPrimary, fontWeight: 500 }}>{t('screens.claimsScreen.new.breadcrumbNew')}</span>
          </div>
          <div style={{ fontSize: 20, fontWeight: 700, color: S.textPrimary }}>{t('screens.claimsScreen.new.fnol')}</div>
        </div>
      </div>

      {/* Progress indicator */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 0 }}>
        {steps.map((s, i) => (
          <div key={s} style={{ display: 'flex', alignItems: 'center', flex: i < steps.length - 1 ? 1 : 'none' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <div
                style={{
                  width: 30,
                  height: 30,
                  borderRadius: 8,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 12,
                  fontWeight: 700,
                  background: step > i + 1 ? '#dcfce7' : step === i + 1 ? `linear-gradient(135deg, ${S.burgundy}, ${S.burgundy2})` : S.bgCard,
                  color: step > i + 1 ? '#15803d' : step === i + 1 ? '#fff' : S.textMuted,
                  border: step > i + 1 ? '1px solid #86efac' : step === i + 1 ? 'none' : `1px solid ${S.borderLight}`,
                }}
              >
                {step > i + 1 ? (
                  <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='#15803d' strokeWidth='1.8' strokeLinecap='round' strokeLinejoin='round'>
                    <path d='M22 11.08V12a10 10 0 1 1-5.93-9.14' />
                    <polyline points='22 4 12 14.01 9 11.01' />
                  </svg>
                ) : (
                  i + 1
                )}
              </div>
              <span style={{ fontSize: 13, fontWeight: step === i + 1 ? 600 : 400, color: step === i + 1 ? S.textPrimary : S.textMuted, whiteSpace: 'nowrap' }}>{s}</span>
            </div>
            {i < steps.length - 1 && <div style={{ flex: 1, height: 2, background: step > i + 1 ? '#86efac' : S.borderLight, margin: '0 16px' }} />}
          </div>
        ))}
      </div>
    </header>
  );
};

export default Header;
